import React, { useState, useEffect } from 'react';
import './Verify.css';

const Verify = ({ organizationId, setView }) => {
  const [status, setStatus] = useState('loading');
  const [orgName, setOrgName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOrganization = async () => {
      if (!organizationId) {
        setStatus('error');
        setError('Invalid verification link');
        return;
      }

      try {
        console.log(`[Verify] Fetching organization: ${organizationId}`);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/organizations/${organizationId}`);
        
        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.error || `Server responded with ${response.status}`);
        }

        const org = await response.json();
        setOrgName(org.companyName || 'your organization');
        
        switch (org.verificationStatus) {
          case 'approved':
            setStatus('approved');
            break;
          case 'rejected':
            setStatus('rejected');
            break;
          case 'pending':
          default:
            setStatus('pending');
            break;
        }
      } catch (err) {
        console.error('[Verify] Error:', err.message);
        setStatus('error');
        setError(err.message.includes('not found') 
          ? 'Organization not found. The link may be invalid or expired.'
          : 'Unable to check verification status right now.');
      }
    };

    fetchOrganization();
  }, [organizationId]);

  const handleGoToLogin = () => setView('login');
  const handleGoHome = () => setView('landing');

  return (
    <div className="verify-container">
      {status === 'loading' && (
        <>
          <h2>Checking Verification...</h2>
          <p>Please wait a moment...</p>
        </>
      )}

      {status === 'approved' && (
        <>
          <h2>Account Verified!</h2>
          <p>Thank you! Your organization <strong>{orgName}</strong> has been successfully verified.</p>
          <p>You can now log in and start listing your deals on Scover.</p>
          <button onClick={handleGoToLogin} className="verify-button">
            Go to Login
          </button>
        </>
      )}

      {status === 'rejected' && (
        <>
          <h2>Verification Not Approved</h2>
          <p>Unfortunately, your organization <strong>{orgName}</strong> could not be verified at this time.</p>
          <p>Please contact our support team at <a href="mailto:support@scover.co.za">support@scover.co.za</a> for more information.</p>
          <button onClick={handleGoHome} className="verify-button">
            Back to Home
          </button>
        </>
      )}

      {status === 'pending' && (
        <>
          <div className="pending-icon">⏳</div>
          <h2>Thank You for Signing Up!</h2>
          <p>Your organization <strong>{orgName}</strong> has been successfully registered.</p>
          <p className="highlight">
            Our team is now manually reviewing your application to ensure everything is correct and legitimate.
          </p>
          <p>
            This process usually takes <strong>24–48 hours</strong> (business days). 
            You will receive an email at your notifications address once your account is approved.
          </p>
          <p className="small">
            In the meantime, thank you for your patience — we're excited to have you join Scover!
          </p>
          <button onClick={handleGoHome} className="verify-button">
            Back to Home
          </button>
        </>
      )}

      {status === 'error' && (
        <>
          <h2>Verification Error</h2>
          <p>{error}</p>
          <p>If this persists, please contact <a href="mailto:support@scover.co.za">support@scover.co.za</a>.</p>
          <button onClick={handleGoHome} className="verify-button">
            Back to Home
          </button>
        </>
      )}
    </div>
  );
};

export default Verify;